import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Capture a DOM node into a multi-page A4 PDF and trigger a download.
 *
 * @param {HTMLElement} node     element to rasterize
 * @param {string}      filename output filename (without extension is fine)
 * @param {object}      [opts]
 * @param {string}      [opts.backgroundColor] override bg (defaults to computed)
 */
export async function downloadElementAsPdf(node, filename, opts = {}) {
  if (!node) return;
  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: opts.backgroundColor || '#FFFFFF',
    useCORS: true,
    allowTaint: false,
    logging: false,
    // Ignore elements that shouldn't render in the PDF (e.g. the download button itself)
    ignoreElements: (el) => el?.dataset?.pdfIgnore === 'true',
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();   // 210 mm
  const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
  heightLeft -= pageHeight;
  while (heightLeft > 0) {
    position = heightLeft - imgHeight; // negative offset pushes next slice up
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
    heightLeft -= pageHeight;
  }

  const safeName = filename.replace(/[^a-z0-9._-]+/gi, '-').toLowerCase();
  pdf.save(safeName.endsWith('.pdf') ? safeName : `${safeName}.pdf`);
}
